<template>
  <div class="popup" @click="click_close_popup">
    <div class="form_popup_container popup_content_container">
      <div class="contact-form">
        <div
          class="w-full max-w-4xl mx-auto text-left bg-white shadow-md rounded px-10 pt-16 pb-6 mb-3 relative"
          @click="prevent_close($event)"
        >
          <div class="option-bar">
            <span href="#" class="close-link" @click="close_popup">X</span>
          </div>
          <ContactFormPage />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactFormPage from "./ContactFormPage";
import { mapGetters } from "vuex";
export default {
  name: "FormPopup",
  components: {
    ContactFormPage
  },
  computed: {
    ...mapGetters(["eventTag"]),
    page_url() {
      var str = "/" + this.eventTag + "/popups/contact-us";

      return str;
    },
    is_closable() {
      return (
        this.$store.state.can_skip_videos || this.$store.state.app_state == 2
      );
    }
  },
  methods: {
    click_close_popup(e) {
      if (this.is_closable) {
        e.preventDefault();
        this.close_popup(e);
      }
    },
    close_popup(e) {
      console.log("close popup");

      //there's a difference between the number of the transition
      //and what unity's animator is expecting for its param.
      //so unity is always one number ahead
      //quick fix is to send transition number minus one, but let's do better next time
      if (this.$store.state.app_state == 0) {
        this.$bus.$emit(
          "send_interactive_msg",
          "JsRequestTransition",
          parseInt(this.$store.state.popup_video_src, 10)
        );
      }
      this.$store.dispatch("set_popup_state", "");

      this.loading = "loading";
      //this.$bus.$emit('send_unity_msg', 'OnVideoPopupClose', null)
    },
    prevent_close(e) {
      e.stopPropagation();
    }
  },

  mounted() {
    console.log("mounted form ");
    this.$bus.$emit("send_unity_msg", "JsOnPopupStateChanged", 1);
    this.$ga.page(this.page_url);
  },
  beforeDestroy() {
    console.log("removed form");
    this.$bus.$emit("send_unity_msg", "JsOnPopupStateChanged", 0);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  width: 100%;
  bottom: 0;
  display: flex;
  flex-flow: column;
  xjustify-content: space-around;
}
.popup_content_container {
  margin-top: auto;
  margin-bottom: auto;
  max-height: calc(var(--vh, 1vh) * 100);
  overflow: auto;
}
.option-bar {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/FormPopup.vue